import type { ViewSwitchInitiatedAction } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';

export const RESULTS_VIEW_SWITCH_INITIATED = 'RESULTS_VIEW_SWITCH_INITIATED';

export const resultsViewSwitchInitiated = (): ViewSwitchInitiatedAction => ({
  type: RESULTS_VIEW_SWITCH_INITIATED,
});
